// noinspection NpmUsedModulesInstalled,DuplicatedCode

import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Paper from '@/modules/common/components/Paper';
import Button from '@/modules/common/components/Button';
import Spinner from '@/modules/common/components/Spinner';
import Content from '@/modules/common/components/Content';
import ErrorFetch from '@/modules/common/components/ErrorFetch';
import Pagination from '@/modules/common/components/Pagination';
import ContentBody from '@/modules/common/components/ContentBody';
import ContentHeader from '@/modules/common/components/ContentHeader';
import ContentBodyTop from '@/modules/common/components/ContentBodyTop';
import DialogChangePassword from '@/modules/common/components/DialogChangePassword';
import { withFetch } from '~/hocs/fetch';
import { withRouter } from '~/hocs/router';
import { actionDockSetExpandUsers } from '@/modules/application/actions/dock';
import Table from './Table';
import DialogAdd from '../DialogAddClient';
import DialogEdit from './DialogEdit';
import ContextMenu from './ContextMenu';
import DialogDelete from './DialogDelete';
import '../../styles/Clients.scss';

const breadcrumbs = [
    {name: 'Пользователи', to: '/users/'},
    {name: 'Клиенты'}
];

let abortController;

const Clients = (props) => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [selectedClient, setSelectedClient] = useState(null);
    const [openDialogAdd, setOpenDialogAdd] = useState(false);
    const [openDialogEdit, setOpenDialogEdit] = useState(false);
    const [openDialogChangePassword, setOpenDialogChangePassword] = useState(false);
    const [openDialogDelete, setOpenDialogDelete] = useState(false);
    const [positionContextMenu, setPositionContextMenu] = useState({left: null, top: null});

    const { enqueueSnackbar } = useSnackbar();

    const fetch = () => {
        abortController = new AbortController();
        setLoading(true);
        props.fetch.get(`/api/clients/?${props.router.urlSearchParams.toString()}`, abortController)
            .then(({ok, data}) => {
                if (ok) {
                    setData(data);
                }
                setLoading(false);
            })
            .catch((error) => {
                setData(null);
                if (error.name !== 'AbortError') {
                    setLoading(false);
                }
            })
            .finally(() => {
                abortController = null;
            });
    };

    const closeContextMenu = () => {
        setPositionContextMenu({left: null, top: null});
    };

    useEffect(() => {
        props.dockSetExpandUsers(true);
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, []);

    useEffect(() => {
        let page = parseInt(props.router.urlSearchParams.get('page'));
        if (isNaN(page)) {
            page = 1;
        }
        // noinspection JSCheckFunctionSignatures
        props.router.urlSearchParams.set('page', page);
        fetch();
    }, [props.history.location.search]);

    /******************************************************************************************************************/

    const handleContextMenu = (client) => (event) => {
        event.preventDefault();
        setSelectedClient(client);
        setPositionContextMenu({left: event.clientX, top: event.clientY});
    };

    const handleClickEdit = () => {
        closeContextMenu();
        setOpenDialogEdit(true);
    };

    const handleClickChangePassword = () => {
        closeContextMenu();
        setOpenDialogChangePassword(true);
    };

    const handleClickDelete = () => {
        closeContextMenu();
        setOpenDialogDelete(true);
    };

    const handleCloseContextMenu = () => {
        closeContextMenu();
        setSelectedClient(null);
    };

    /******************************************************************************************************************/

    const handleAddOk = () => {
        setOpenDialogAdd(false);
        props.router.reload();
        enqueueSnackbar('Клиент добавлен', {variant: 'success'});
    };

    const handleEditOk = () => {
        setOpenDialogEdit(false);
        setSelectedClient(null);
        props.router.reload();
        enqueueSnackbar('Клиент изменен', {variant: 'success'});
    };

    const handleDeleteOk = () => {
        setOpenDialogDelete(false);
        setSelectedClient(null);
        props.router.reload();
        enqueueSnackbar('Клиент удален', {variant: 'success'});
    };

    /******************************************************************************************************************/

    // noinspection JSUnresolvedVariable
    return (
        <Content id="clients">
            <ContentHeader breadcrumbs={breadcrumbs}/>
            <ContentBody><Paper>
                {(!loading)
                    ? <>
                        {(data && data.results)
                            ? <>
                                <ContentBodyTop left={
                                    <Button onClick={() => setOpenDialogAdd(true)}>Добавить</Button>
                                }/>
                                <DialogAdd open={openDialogAdd} setOpen={setOpenDialogAdd} onOk={handleAddOk}/>
                                {(data.results.length > 0)
                                    ? <>
                                        <Table clients={data.results} selectedClient={selectedClient}
                                               onContextMenu={handleContextMenu}
                                        />
                                        <ContextMenu position={positionContextMenu}
                                                     onClickEdit={handleClickEdit}
                                                     onClickChangePassword={handleClickChangePassword}
                                                     onClickDelete={handleClickDelete}
                                                     onClose={handleCloseContextMenu}
                                        />
                                        <DialogEdit selectedClient={selectedClient}
                                                    setSelectedClient={setSelectedClient}
                                                    open={openDialogEdit} setOpen={setOpenDialogEdit}
                                                    onOk={handleEditOk}
                                        />
                                        <DialogChangePassword username={(selectedClient) ? selectedClient.username : ''}
                                                              setSelected={setSelectedClient}
                                                              open={openDialogChangePassword}
                                                              setOpen={setOpenDialogChangePassword}
                                        />
                                        <DialogDelete selectedClient={selectedClient}
                                                      setSelectedClient={setSelectedClient}
                                                      open={openDialogDelete} setOpen={setOpenDialogDelete}
                                                      onOk={handleDeleteOk}
                                        />
                                        <Pagination totalPages={data.total_pages} currentPage={data.current_page}/>
                                    </>
                                    : null
                                }
                            </>
                            : <ErrorFetch onClick={() => fetch()}/>
                        }
                    </>
                    : <Spinner/>
                }
            </Paper></ContentBody>
        </Content>
    );
};

let Component = Clients;
Component = withRouter(Component);
Component = withFetch(Component);

export default connect(
    null,
    (dispatch) => ({
        dockSetExpandUsers: bindActionCreators(actionDockSetExpandUsers, dispatch),
    })
)(Component);
